import { CSS } from '@grupoboticario/flora-react'

export const outerBoxCss: CSS = {
  marginBottom: '$6',
  marginTop: '$2',
  border: '1px solid $nonInteractiveOutline',
  borderRadius: '4px',
  backgroundColor: '#fff'
}

export const outerBoxReadOnlyCss: CSS = {
  ...outerBoxCss,
  backgroundColor: '$disabledBackground'
}

export const toolbarContainerCss: CSS = {
  borderBottom: '1px solid $nonInteractiveOutline',
  borderRadius: '4px 4px 0 0'
}

export const toolbarCss: CSS = {
  padding: '$2',
  gap: '$1'
}

export const formattingButtonBaseCss: CSS = {
  minWidth: '28px',
  height: '28px',
  padding: '0',
  backgroundColor: 'transparent',
  borderRadius: '2px',
  color: '$medium-light-1',
  '&:hover': {
    backgroundColor: '$light-dark-1'
  }
}

export const getFormattingButtonCss = (style: CSS): CSS => ({
  ...formattingButtonBaseCss,
  ...style
})
